import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const MailOutline: React.FC<SvgIconProps> = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M20.976 5L3.024 5C2.1825 5 1.5 5.6825 1.5 6.524L1.5 18.476C1.5 19.3175 2.1825 20 3.024 20H20.976C21.8175 20 22.5 19.3175 22.5 18.476V6.524C22.5 5.6825 21.8175 5 20.976 5ZM19.3328 6.515L12.0262 13.4188C11.9978 13.4398 11.9618 13.4517 11.9235 13.4517C11.8853 13.4517 11.8492 13.439 11.82 13.418H11.8207L4.5165 6.51425L19.3328 6.51425V6.515ZM3 18.476L3.0225 7.16675L10.7917 14.5085C11.0887 14.783 11.487 14.9517 11.925 14.9517C12.363 14.9517 12.7613 14.783 13.059 14.5077L13.0582 14.5085L21 7.004L20.976 18.5L3 18.476Z" />
  </SvgIcon>
);
